module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_06-572f38a9506fb64c24f872569892a987.svg";